module.exports = __webpack_public_path__ + "img/6.79051448.jpg";